module.exports = __webpack_public_path__ + "static/img/zj-pic4.34349e47.png";